module.exports = "/_next/static/images/dlya-avto-6a155a004a89a5c0b4088d5ea319a5b3.svg";